import React, { useRef } from "react";

var fileSelector: HTMLInputElement | undefined = undefined;

export const FileUpload: React.FC<any> = ({
  children,
  handleUpload,
  className,
  style,
}) => {
  const importUserCode = () => {
    if (typeof fileSelector === "undefined") {
      fileSelector = document.createElement("input");
      fileSelector.type = "file";
      document.body.appendChild(fileSelector);

      fileSelector.onchange = (e) => {
        if (!fileSelector?.files || fileSelector?.files?.length !== 1) return;

        let reader = new FileReader();
        reader.readAsText(fileSelector?.files[0], "UTF-8");

        reader.onload = (e) => {
          const data = e?.target?.result;
          console.log(data);
        };

        reader.onerror = (e) => {
          // message.error("File could not imported", 2);
        };
      };
    }

    fileSelector.click();
  };

  return (
    <>
      <span className={className} style={style} onClick={importUserCode}>
        {children}
      </span>
      <input
        type="file"
        onChange={(e) => handleUpload(e.target.files?.[0])}
        style={{ display: "none" }}
      />
    </>
  );
};
